import talentRequisitionStore from "./talent-requisition/store";
import jobPostingStore from "./job-posting/store";
import trackingStore from "./tracking/store";

export default {
  namespaced: true,
  modules: {
    talent: talentRequisitionStore,
    posting: jobPostingStore,
    tracking: trackingStore,
  },
};
